// Central SEO configuration + helpers for AETHER.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://aether-live.com").replace(/\/$/, "");
export const SITE_NAME = "AETHER";
export const DEFAULT_TITLE = "AETHER — AI-Designed Sci-Fi Apparel & Immersive Worlds";
export const DEFAULT_DESC =
  "Design custom sci-fi apparel with an AI-powered studio, explore immersive simulation worlds, and order premium print-on-demand t-shirts & hoodies. Wear the Simulation.";

export const ogDefault = `${BACKEND}/api/seo/og/default.png`;
export const ogProduct = (id) => `${BACKEND}/api/seo/og/product/${id}.png`;
export const ogDesign = (id) => `${BACKEND}/api/seo/og/design/${id}.png`;
export const canonical = (path = "/") => `${SITE_URL}${path}`;

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: ogDefault,
  description: DEFAULT_DESC,
  sameAs: [],
};

export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/shop?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export const productJsonLd = (p) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: p.name,
  description: p.description,
  image: [ogProduct(p.product_id), p.image].filter(Boolean),
  brand: { "@type": "Brand", name: SITE_NAME },
  category: p.type,
  offers: {
    "@type": "Offer",
    url: canonical(`/shop/product/${p.product_id}`),
    priceCurrency: "USD",
    price: Number(p.price || 0).toFixed(2),
    availability: "https://schema.org/InStock",
    itemCondition: "https://schema.org/NewCondition",
  },
});

export const designJsonLd = (d, id) => ({
  "@context": "https://schema.org",
  "@type": "CreativeWork",
  name: d.name,
  url: canonical(`/d/${id}`),
  image: ogDesign(id),
  creator: { "@type": "Organization", name: SITE_NAME },
});

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: canonical(it.path),
  })),
});
